import React from 'react';
import '../Services.css';
import Image1 from '../../Gemco-Website-Images/Services/Electrical_panel.jpg';

const Service_three = () => {
  return (
    <div className='wp_sub_service'>
      <div className="container wp_sub_service_container">
          <div className="row wp_service_row">
            <div className="content-column">
              <div className="inner-column wp_service_inner_column">
                <div className='sec-title forseotitle wp_service_sec_title'>
                  <h1>Power Upgrade Works</h1>
                  <p>Complete LV electrical infrastructure upgrades for operating facilities — carried out safely with
                      minimum disruption to live operations. From single panel upgrades to full campus power
                      infrastructure overhaul with shutdown planning and execution.</p>
                    <ul>
                      <li className="service_list_item">LV cable supply and installation — armoured and unarmoured</li>
                      <li className="service_list_item">MDB, SMDB and DB panel upgrades and replacements</li>
                      <li className="service_list_item">Automatic Transfer Switch (ATS) and capacitor bank installation</li>
                      <li className="service_list_item">Cable containment</li>
                      <li className="service_list_item">trenching and route works</li>
                      <li className="service_list_item">Shutdown planning and execution — DEWA and client coordination</li>
                      <li className="service_list_item">Structural and civil modifications for cable routes</li>
                      <li className="service_list_item">Testing: megger, continuity</li>
                      <li className="service_list_item">load and power quality</li>
                      <li className="service_list_item">Final energisation support and commissioning</li>
                    </ul>
                </div>
              </div>
            </div>
            <div className="image-column">
              <img src={Image1} width="500" height="400" alt="" />
            </div>
          </div>
      </div>
    </div>
  )
}

export default Service_three